var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNaverPay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 52 28",
    viewBox: "0 0 52 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#03c75a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.308 11.013-1.598 3.64-1.808-3.64h-1.391l2.562 5.051-1.056 2.358h1.35l3.291-7.409zm-5.567 5.629h-1.321v-.525c-.477.412-1.048.64-1.738.64-1.581 0-2.817-1.286-2.817-2.929s1.236-2.929 2.817-2.929c.689 0 1.261.228 1.738.64v-.525h1.321zm-1.166-2.814c0-1.061-.741-1.867-1.723-1.867s-1.723.806-1.723 1.867.741 1.867 1.723 1.867 1.723-.806 1.723-1.867zm-11.275 4.595h1.379v-2.258c.465.381 1.018.592 1.68.592 1.581 0 2.817-1.286 2.817-2.929s-1.236-2.929-2.817-2.929c-.689 0-1.261.228-1.738.64v-.525h-1.321zm2.89-6.462c.982 0 1.723.806 1.723 1.867s-.741 1.867-1.723 1.867-1.723-.806-1.723-1.867.74-1.867 1.723-1.867z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.831 14c0 3.172-2.572 5.744-5.744 5.744s-5.744-2.572-5.744-5.744 2.572-5.744 5.744-5.744 5.744 2.572 5.744 5.744zm-4.783-2.7v2.889l-2.006-2.889h-1.655v5.4h1.739v-2.889l2.006 2.889h1.655v-5.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNaverPay);
export default __webpack_public_path__ + "static/media/icon-naver-pay.9e910f7897d562aa0e7cb0e55f806ec2.svg";
export { ForwardRef as ReactComponent };